var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0852 15.6788C10.2094 15.6179 10.3141 15.5234 10.3874 15.4061C10.4607 15.2888 10.4997 15.1533 10.5 15.015V11.025C10.5 10.8285 10.5788 10.6395 10.7198 10.5L15.3105 5.95951C15.5917 5.68126 15.75 5.30326 15.75 4.90951V2.99251C15.7496 2.89449 15.7299 2.7975 15.692 2.7071C15.654 2.61671 15.5987 2.53468 15.529 2.46571C15.4593 2.39674 15.3768 2.34219 15.286 2.30518C15.1952 2.26817 15.098 2.24942 15 2.25001H3C2.58525 2.25001 2.25 2.58151 2.25 2.99251V4.90951C2.25 5.30326 2.40825 5.68126 2.6895 5.95951L7.28025 10.5C7.34981 10.5686 7.40505 10.6504 7.44277 10.7405C7.48049 10.8306 7.49995 10.9273 7.5 11.025V15.7575C7.5 16.3088 8.0865 16.6673 8.58525 16.4205L10.0852 15.6788Z",
    fill: "#090909"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.475673b1c0cc9e2edd033065917463fb.svg";
export { ForwardRef as ReactComponent };